import { ArrowBack, ArrowNext } from "./styles"
import { useShowCarouselButtons } from "hooks";

const Buttons =({
  classPrev,
  classNext,
  nextSlide,
  prevSlide
}) => {
  const { showNavigationBtns } = useShowCarouselButtons();

  if (!showNavigationBtns) return null

  return (
    <>
      <ArrowBack
        className={classPrev}
        onClick={prevSlide}
      />
      <ArrowNext
        className={classNext}
        onClick={nextSlide}
      />
    </>
  )
}

export default Buttons